import PaymentModalComponent from './payment-modal.component'

const PaymentModalModule = angular.module('cdbl.payment-modal', [

])
  .component('cdblPaymentModal', PaymentModalComponent)
  .name

export default PaymentModalModule
